/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PortalLinkService } from '@nha/api/core';
import { NHASnackbarService } from '@nha/components/snack-bar/snack-bar.service';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import * as fromAction from './portal-link.actions';

@Injectable()
export class PortalLinkEffects {
	private _actions$ = inject(Actions);
	private _portalService = inject(PortalLinkService);
	private _snackBarService = inject(NHASnackbarService);

	loadPortalLinks$ = createEffect(() =>
		this._actions$.pipe(
			ofType(fromAction.LoadPortalLinks),
			switchMap((action) =>
				this._portalService.getForUser().pipe(
					map((portalLinks) => fromAction.SetPortalLinks({ portalLinks })),
					catchError((e) => {
						this._snackBarService.error(`Request failed for action ${fromAction.LoadPortalLinks.type}`, 'Dismiss', {
							duration: 3000
						});
						return of(null);
					})
				)
			)
		)
	);

	setFavorite$ = createEffect(() =>
		this._actions$.pipe(
			ofType(fromAction.SetFavorite),
			concatMap((action) =>
				this._portalService.toggleFavorite(action.portalLinkID).pipe(
					map((portalLinkIDs) => fromAction.UpdateFavorites({ portalLinkIDs })),
					catchError((e) => {
						this._snackBarService.error(`Request failed for action ${fromAction.SetFavorite.type}`, 'Dismiss', {
							duration: 3000
						});
						return of(null);
					})
				)
			)
		)
	);

	updateFavoritesOrder$ = createEffect(() =>
		this._actions$.pipe(
			ofType(fromAction.updateFavoritesOrder),
			switchMap((action) => {
				return this._portalService.updateFavoritesOrder(action.portalLinks).pipe(
					map((_) => fromAction.updateFavoritesOrderSuccess({ portalLinks: action.portalLinks })),
					catchError((err) => of(fromAction.updateFavoritesOrderFail({ err })))
				);
			})
		)
	);

	updateQuickLinksOrder$ = createEffect(() =>
		this._actions$.pipe(
			ofType(fromAction.updateQuickLinksOrder),
			switchMap((action) => {
				return this._portalService.updateQuickLinksOrder(action.portalLinks).pipe(
					map((_) => fromAction.updateQuickLinksOrderSuccess({ portalLinks: action.portalLinks })),
					catchError((err) => of(fromAction.updateQuickLinksOrderFail({ err })))
				);
			})
		)
	);
}
